import { gql } from '@apollo/client';

import { PracticeSession } from '../../types';
import { PracticeSessionFragment } from '../fragments';

export interface GetPracticeSessionsQueryVariables {
  courseId: string;
}

export interface GetPracticeSessionsQueryResult {
  practiceSessions: PracticeSession[];
}

export const getPracticeSessionsQuery = gql`
  query GetPracticeSessionsQuery($courseId: String!) {
    practiceSessions(courseId: $courseId) @rest(type: "PracticeSession", path: "courses/{args.courseId}/practice") {
      ...PracticeSession
    }
  }
  ${PracticeSessionFragment}
`;
